import * as React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import { Input } from "@abb/abb-common-ux-react";
import SubmitHeader from "../shared/SubmitHeader";
import history from "../../utilities/History";
import sourceActions from "../../flux/actions/SourceActions";
import sourceFormStore from "../../flux/stores/source/FormStore";
import ISourceFormData, {
  SourceFormData,
} from "../../models/source/SourceFormData";
import navigationHeaderActions from "../../flux/actions/NavigationHeaderActions";
import * as CONSTANTS from "../../utilities/Constants";
import * as ICONCONSTANTS from "../../utilities/IconConstants";
import submitHeaderActions from "../../flux/actions/SubmitHeaderActions";
import IFormComponent from "../../models/shared/FormComponent";
import triggerNotifications from "../../utilities/TriggerNotifications";
import { Translation } from "react-i18next";
import sourceListStore from "../../flux/stores/source/ListStore";
import { ISourceViewData } from "../../models/source/SourceViewData";
import IdGenerator from "../../utilities/GenerateId";

type PropsType = RouteComponentProps & {};

interface IState {
  sourceFormData: ISourceFormData;
  oldData: ISourceFormData;
  formLoading: boolean;
  nameError: boolean;
  customeIdError: boolean;
  customStripError: boolean;
}

class Form
  extends React.Component<PropsType, IState>
  implements IFormComponent {
  _mount: boolean;
  _isReload: boolean;
  _id: string;
  _messages: string[];
  _listData: any[];

  constructor(props: PropsType) {
    super(props);
    const pushStateData = this.props.location.state as ISourceFormData;

    this.state = {
      sourceFormData: pushStateData,
      formLoading: false,
      oldData: { ...pushStateData },
      nameError: false,
      customeIdError: false,
      customStripError: false,
    };
    this._mount = false;
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidUpdate() {
    if (
      JSON.stringify(this.state.oldData) !==
      JSON.stringify(this.state.sourceFormData)
    ) {
      navigationHeaderActions
        .updateHeader({
          name: CONSTANTS.MODULE_SOURCE,
          action: this.state.sourceFormData.isEditMode
            ? CONSTANTS.EDIT
            : CONSTANTS.CREATE,
          icon: this.state.sourceFormData.isEditMode
            ? ICONCONSTANTS.ABB_EDIT
            : ICONCONSTANTS.ABB_PLUS,
          goBackUrl: CONSTANTS.SOURCE_INDEX_URL,
          isGoBackWithData: false,
          goBackData: {},
          isDataChanged: true,
        })
        .then();
    }
  }

  componentDidMount() {
    this._mount = true;

    sourceActions
      .getAll(
        1,
        CONSTANTS.PAGE_SIZE,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then();

    if (this.state.sourceFormData?.isEditMode) {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_SOURCE,
          isSubmitDisabled: false,
        })
        .then();
    }
    navigationHeaderActions
      .updateHeader({
        name: CONSTANTS.MODULE_SOURCE,
        action: this.state.sourceFormData?.isEditMode
          ? CONSTANTS.EDIT
          : CONSTANTS.CREATE,
        icon: this.state.sourceFormData?.isEditMode
          ? ICONCONSTANTS.ABB_EDIT
          : ICONCONSTANTS.ABB_PLUS,
        goBackUrl: CONSTANTS.SOURCE_INDEX_URL,
        isGoBackWithData: false,
        goBackData: {},
        isDataChanged: false,
      })
      .then();

    sourceFormStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._isReload = false;
        this._id = state.Id;
        this._messages = state.message;
      }
    });

    // if(!this.state.sourceFormData?.isEditMode){
    //   sourceListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
    //     if (this._mount) {
    //       this._listData = state.sourceDataList.result as ISourceViewData[];
    //       const code = this._listData[0].code;
    //       const id = IdGenerator.incrementId(code);
    //       const idString = id.toString();
  
    //       this.setState({
    //         sourceFormData: {
    //           ...this.state.sourceFormData,
    //           code: idString
    //         }
    //       });
    //     }
    //   });
    // }
  }

  private setName = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (
      value.trim() &&
      !rgFile.test(value)
    ) {
      this.setState(
        {
          nameError: false,
          sourceFormData: {
            ...this.state.sourceFormData,
            name: val,
          },
        },
        this.validate
      );
    } else {
      this.setState(
        {
          nameError: true,
          sourceFormData: {
            ...this.state.sourceFormData,
            name: val,
          },
        },
        this.validate
      );
    }
  };

  private setDescription = (value: string) => {
    this.setState({
      sourceFormData: {
        ...this.state.sourceFormData,
        description: value,
      },
    });
  };
  private setCode = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (value.trim() === "" || (!rgFile.test(value) && value.trim())) {
      this.setState(
        {
          customeIdError: false,
          sourceFormData: {
            ...this.state.sourceFormData,
            code: val,
          },
        },
        this.validate
      );
    } else {
      this.setState(
        {
          customeIdError: true,
          sourceFormData: {
            ...this.state.sourceFormData,
            code: val,
          },
        },
        this.validate
      );
    }
  };

  private setStripLength = (value: any) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");

    if (val == "0") {
      return;
    }

    if (value.trim() && /^[0-9]*$/g.test(value)) {
      this.setState(
        {
          customStripError: false,
          sourceFormData: {
            ...this.state.sourceFormData,
            stripLength: val,
          },
        },
        this.validate
      );
    } else {
      this.setState(
        {
          customStripError: true,
          sourceFormData: {
            ...this.state.sourceFormData,
            stripLength: val,
          },
        },
        this.validate
      );
    }
  };

  validate(): void {
    if (
      !this.state.nameError &&
      !this.state.customeIdError &&
      this.state.sourceFormData.name &&
      this.state.sourceFormData.name.trim() &&
      this.state.sourceFormData.stripLength &&
      !this.state.customStripError
    ) {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_SOURCE,
          isSubmitDisabled: false,
        })
        .then();
    } else {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_SOURCE,
          isSubmitDisabled: true,
        })
        .then();
    }
  }

  public onSaveClick = () => {
    const tempName = this.state.sourceFormData.name
      .replace(/ +(?= )/g, "")
      .trim();
    this.setState(
      (prevState) => ({
        formLoading: true,
        sourceFormData: {
          ...prevState.sourceFormData,
          name: tempName,
        },
      }),
      () => {
        const data = new SourceFormData(
          this.state.sourceFormData.isEditMode,
          this.state.sourceFormData.requestId,
          this.state.sourceFormData.id,
          this.state.sourceFormData.name,
          this.state.sourceFormData.description,
          this.state.sourceFormData.code,
          this.state.sourceFormData.width,
          this.state.sourceFormData.stripLength
        );

        sourceActions
          .put(data)
          .then(() => {
            this.setState(
              {
                formLoading: false,
              },
              () => {
                triggerNotifications.success(this._messages);
                setTimeout(() => {
                  history.push("/source", {
                    isReloadFirst: this._isReload,
                    id: this._id,
                  });
                }, CONSTANTS.NOTIFICATION_TIMEOUT);
              }
            );
          })
          .catch((error) => {
            this.setState(
              {
                formLoading: false,
              },
              () =>
                triggerNotifications.errors(error.message, error.data).then()
            );
          });
      }
    );
  };

  public onCreateClick = () => {
    const tempName = this.state.sourceFormData.name
      .replace(/ +(?= )/g, "")
      .trim();
    this.setState(
      (prevState) => ({
        formLoading: true,
        sourceFormData: {
          ...prevState.sourceFormData,
          name: tempName,
        },
      }),
      () => {
        const data = new SourceFormData(
          this.state.sourceFormData.isEditMode,
          this.state.sourceFormData.requestId,
          this.state.sourceFormData.id,
          this.state.sourceFormData.name,
          this.state.sourceFormData.description,
          this.state.sourceFormData.code,
          this.state.sourceFormData.width,
          this.state.sourceFormData.stripLength
        );

        sourceActions
          .post(data)
          .then(() => {
            this.setState(
              {
                formLoading: false,
              },
              () => {
                triggerNotifications.success(this._messages);
                setTimeout(() => {
                  history.push("/source", {
                    isReloadFirst: this._isReload,
                    id: this._id,
                  });
                }, CONSTANTS.NOTIFICATION_TIMEOUT);
              }
            );
          })
          .catch((error) => {
            this.setState(
              {
                formLoading: false,
              },
              () =>
                triggerNotifications.errors(error.message, error.data).then()
            );
          });
      }
    );
  };

  onCancelClick = () => {
    history.push(CONSTANTS.SOURCE_INDEX_URL, {
      isReloadFirst: this._isReload,
      id: this._id,
    });
  };

  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-scroll">
            <div className="layout-container">
              <SubmitHeader
                name={t(CONSTANTS.MODULE_SOURCE)}
                link={CONSTANTS.PATH_SOURCE}
                isEdit={this.state.sourceFormData?.isEditMode}
                onSaveClick={this.onSaveClick}
                onCreateClick={this.onCreateClick}
                onCancelClick={this.onCancelClick}
                isLoading={this.state.formLoading}
              />
              <div className="mt-3">
                <div className="col-6 no-padding float-left">
                  <div className="box">
                    <div className="box-circle">
                      <p className="box-circle-text"> 1 </p>
                    </div>
                    <div className="ml-4">
                      <p className="sidebar-main-title font-weight-bold ml-2">
                        {t(CONSTANTS.MODULE_SOURCE) +
                          " " +
                          t(CONSTANTS.TITLE_TESTOVERVIEW_DETAILS)}
                      </p>
                    </div>
                    <hr className="hr-line" />

                    <div className="row mt-3">
                      <div className="col-sm col-md">
                        <Input
                          className={
                            this.state.customeIdError
                              ? "error-code mt-2 w-25"
                              : "mt-2 w-25"
                          }
                          dataType="text"
                          label={t(CONSTANTS.SOURCE_CODE)}
                          placeholder={t(CONSTANTS.SOURCE_CODE)}
                          // required={true}
                          value={String(this.state.sourceFormData?.code)}
                          onValueChange={this.setCode}
                          maxLength={10}
                          showValidationBarWhenInvalid={
                            this.state.customeIdError ? true : false
                          }
                          description={
                            this.state.customeIdError
                              ? this.state.sourceFormData?.code?.length
                                ? t(CONSTANTS.NAME_VALIDATION_ERROR)
                                : t(CONSTANTS.FIELD_EMPTY_ERROR)
                              : ""
                          }
                        />
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-sm col-md">
                        <Input
                          inputAttributes={{ autoFocus: "true" }}
                          dataType="text"
                          placeholder={t(CONSTANTS.LABLE_NAME)}
                          label={t(CONSTANTS.LABLE_NAME)}
                          required={true}
                          className={
                            this.state.nameError
                              ? "error-code mt-2 w-50"
                              : "mt-2 w-50"
                          }
                          value={this.state.sourceFormData?.name}
                          onValueChange={this.setName}
                          maxLength={250}
                          showValidationBarWhenInvalid={
                            this.state.nameError ? true : false
                          }
                          description={
                            this.state.nameError
                              ? this.state.sourceFormData?.name?.length
                                ? t(CONSTANTS.NAME_VALIDATION_ERROR)
                                : t(CONSTANTS.FIELD_EMPTY_ERROR)
                              : ""
                          }
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-sm col-md">
                        <Input
                          dataType="textarea"
                          label={t(CONSTANTS.LABEL_DESCRIPTION)}
                          placeholder={t(CONSTANTS.LABEL_DESCRIPTION)}
                          value={this.state.sourceFormData?.description}
                          onValueChange={this.setDescription}
                          inputAttributes={{ rows: "4" }}
                          className="mt-2 h-25"
                          resizable={false}
                          maxLength={200}
                        />
                      </div>
                    </div>
                    <div className="p-3">
                      {200 - this.state.sourceFormData?.description?.length}{" "}
                      {t("character left out of 200 character")}
                    </div>
                  </div>
                </div>  

                <div className="col-6 no-padding float-left">
                  <div className="box box-height-1 ml-3">
                    <div className="box-circle">
                      <p className="box-circle-text"> 2 </p>
                    </div>
                    <div className="ml-4">
                      <p className="sidebar-main-title font-weight-bold ml-2">
                        {t(CONSTANTS.LABLE_ADDITIONAL_INFORMATION)}
                      </p>
                    </div>
                    <hr className="hr-line" />
                    <Input
                      dataType="text"
                      placeholder={t(CONSTANTS.LABEL_STRIP_LENGTH)}
                      label={t(CONSTANTS.LABEL_STRIP_LENGTH)}
                      required={true}
                      className={
                        this.state.customStripError
                          ? "error-code mt-2 w-50"
                          : "mt-2 w-50"
                      }
                      value={String(this.state.sourceFormData?.stripLength)}
                      onValueChange={this.setStripLength}
                      maxLength={10}
                      showValidationBarWhenInvalid={
                        this.state.customStripError ? true : false
                      }
                      description={
                        this.state.customStripError
                          ? this.state.sourceFormData.stripLength
                            ? t(CONSTANTS.NAME_VALIDATION_ERROR)
                            : t(CONSTANTS.FIELD_EMPTY_ERROR)
                          : ""
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default withRouter(Form);
